import { isProduction } from '../../constants/environment';

const developmentApi = {
  // Use relative URL in development so the proxy can forward it
  SERVER_URL: "/api/",
  WEBSOCKET_URL: "ws://localhost:8080/ws",
  SOCKET_PORT: 8080,
} as const;

const productionApi = {
  SERVER_URL: "https://api.wildchipspoker.com/api/",
  WEBSOCKET_URL: "wss://api.wildchipspoker.com/ws",
  SOCKET_PORT: 443,
} as const;

export const Api = isProduction ? productionApi : developmentApi;

